













































































import { Component, Vue, Watch } from 'vue-property-decorator';
import axios from 'axios';
import { api } from '@/api';
import { State, Getter, Action, Mutation } from 'vuex-class';
import { Debounce } from 'lodash-decorators';

@Component
export default class Languages extends Vue {

    public languageName: string = '';
    public language: any = {
        id: null,
        en: {
            name: ''
        },
        sr: {
            name: ''
        },
    }
    
    public pagination: any = {
        per_page: 10,
        page: 1,
    }
    public totalItems: any = 1;

    public languages: any[] = [];

    public languagesLoading: boolean = true;

    public dialog: boolean = false;

    public isUpdate: boolean = false;

    public $refs!: {
        form: HTMLFormElement // fix for this.$refs.form.valdiate(); TS error
    }

    get headersLocalized(): any[] {
        return [
            {
                text: this.$t('table_headers.translated_shared.en.name'),
                value: 'translations.en.name'
            },
            {
                text: this.$t('table_headers.translated_shared.sr.name'),
                value: 'translations.sr.name'
            },
            {
                text: this.$t('table_headers.shared.actions'),
                value: 'actions',
                align: 'end'
            }
        ]
    }

    public close () {
        this.dialog = false;
        this.isUpdate = false;
        this.$refs.form.reset();
    }

    public save () {

        if (this.isUpdate) {
            return this.update();
        }
        
        this.submit();
    }

    public edit(item: any) {
        this.isUpdate = true;
        this.dialog = true;
        this.language = { 
            id: item.id,
            en: {
                name: (item.translations.en) ? item.translations.en.name : '',
            },
            sr: {
                name: (item.translations.sr) ? item.translations.sr.name : '',
            },
        };
    }

    public async loadLanguages() {

        this.languagesLoading = true;

        /* await this.fetchLanguages(); */
        let payload = {
            page: this.pagination.page,
            per_page: this.pagination.per_page,
        }
        let response = await axios.get(api.path('v1.admin.languages'), { params: payload });

        this.languages = response.data.data;
        this.totalItems = response.data.meta.total;
        this.languagesLoading = false
    }

    public async reloadLanguages() {
        this.languagesLoading = true;

        await this.refreshLanguages(); // refreshes vuex for general use
        await this.loadLanguages(); // reloads current table with translations

        this.languagesLoading = false
        this.close();
    }

    public getPayload() {
        return {
            id: this.language.id,
            en: this.language.en,
            sr: this.language.sr,
        };
    }

    public submit() {

        let payload = this.getPayload();

        axios.post(api.path('v1.admin.languages'), payload )
            .then( res => this.reloadLanguages() );
    }

    public update() {

        let payload = this.getPayload();

        axios.patch(api.path('v1.admin.languages.single', { id: payload.id }), payload )
            .then( res => this.reloadLanguages() );
    }

    /* @Action('languages/fetchLanguages') fetchLanguages: any; */
    @Action('languages/refreshLanguages') refreshLanguages: any;
    /* @Getter('languages/languages') languages: any; */

    @Watch('pagination', { deep: true })
    @Debounce(500)
    onFilterValueChange( value: any ) {
        this.loadLanguages();
    }

    public async mounted() {
        
        await this.loadLanguages();
        
    }

}
